import { Component, Input, OnInit } from '@angular/core';
import { defaultImagePlaceholder } from '../../../constants/images.constants';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrls: ['./how-it-works.component.scss'],
  standalone: false
})
export class HowItWorksComponent implements OnInit {
  imagePlaceholder = defaultImagePlaceholder;
  environment = environment;

  @Input() classList: string;

  constructor() {}

  ngOnInit(): void {}
}
